import React, { useContext, useState } from "react";
import GridItemText from "./GridItemText";
import { Button, Grid, MenuItem, Select, useMediaQuery } from "@mui/material";
import module from "./FormSelfInformation.module.css";
import { searchBankName } from "../../../util/bankCode";
import SearchButtonArea from "./SearchButtonArea";
import { useTheme } from "@emotion/react";
import { RewardSettingContext } from "../../../contexts/RewardSettingContext";

const BankInfoForm = () => {
  const [inputtedBankName, setInputtedBankName] = useState("");
  const [banks, setBanks] = useState([]);
  const { bank, setBankName, clearBankInput } =
    useContext(RewardSettingContext);
  const { bankName, bankCode } = bank.inputted;

  const theme = useTheme();
  const isPc = useMediaQuery(theme.breakpoints.up("md"));

  const getBankInfo = async () => {
    try {
      const banks = await searchBankName(inputtedBankName);
      if (banks) {
        setBanks(banks);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeBankName = (e) => {
    setInputtedBankName(e.target.value);
  };

  const handleSelect = (e) => {
    const bank = banks.find((bank) => bank.code === e.target.value);
    setBanks([]);
    setInputtedBankName("");
    setBankName(bank.name, bank.code);
  };

  const handleClear = () => {
    clearBankInput();
    setBanks([]);
    setInputtedBankName("");
  };

  const isDisabledClear = () => {
    if (!bankCode) return true;
    if (bank.invalidBank) return false;
    if (bank.saved) return true;
    return false;
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          marginBottom: isPc ? "0px" : "24px",
          justifyContent: isPc ? "center" : "end",
        }}
      >
        <GridItemText
          xs={isPc ? 8 : 12}
          label="銀行名"
          placeholder={"例: 三井住友銀行"}
          id={"bank_name"}
          name={"bank_name"}
          defaultValue={inputtedBankName || bankName}
          onChange={handleChangeBankName}
        />
        <SearchButtonArea
          handleSearch={getBankInfo}
          handleClear={handleClear}
          clearDisabled={isDisabledClear()}
        />
      </Grid>
      {banks.length > 0 && (
        <Grid item xs={6} sx={{ textAlign: "left", marginBottom: "24px" }}>
          <label className={module.label}>{"銀行を選択してください"}</label>
          <span className={module.labelRequire}>*</span>
          <Select fullWidth value={bankCode || ""} onChange={handleSelect}>
            <MenuItem value={""} disabled>{"選択してください"}</MenuItem>
            {banks.map((bank) => (
              <MenuItem key={bank.code} value={bank.code}>{bank.name}</MenuItem>
            ))}
          </Select>
        </Grid>
      )}
      {bankCode && (
        <GridItemText
          label="銀行コード(自動入力)"
          placeholder={""}
          name={"bank_code"}
          value={bankCode || ""}
          disabled
        />
      )}
    </>
  );
};

export default BankInfoForm;
